import React, { useEffect, useState } from 'react';
import { Grid, Box, Hidden } from '@material-ui/core';
import Typed from 'typed.js';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import bushome from '../../assets/images/bushome.png';
import featured from '../../assets/images/featured-reo-de-janeiro-brazil.jpg';
import featuredaustralia from '../../assets/images/featured-north-bondi-australia.jpg';
import featuredgermany from '../../assets/images/featured-berlin-germany.jpg';
import featuredthailand from '../../assets/images/featured-khwaeng-wat-arun-thailand.jpg';
import featureditaly from '../../assets/images/featured-rome-italy.jpg';
import featuredmaldives from '../../assets/images/featured-fuvahmulah-maldives.jpg';
import header from '../../assets/images/services-bg.jpg';
import service from '../../assets/images/header-bg.jpg';
import pngwin from '../../assets/images/pngwin.png';
import './Homepage2.css';
import test1 from '../../assets/images/test-1.jpg';
import test2 from '../../assets/images/test-2.jpg';
import test3 from '../../assets/images/avt.jpg';
import SearchFlightNew from '../../form/SearchFlightNew';
import flightnew from '../../assets/images/flightnew.svg';
import trainnew from '../../assets/images/trainnew.svg';
import busnew from '../../assets/images/busnew.svg';
import hotelnew from '../../assets/images/hotelnew.svg';
import TitleText from '../../components/reusableComponents/TitleText';
import { useDispatch } from 'react-redux';
import { fetchBannerDispatch } from '../../reducers/BannerReducer';
import { fetchCityDispatch } from '../../reducers/HomeReducer';
import { useHistory } from 'react-router-dom';
import SearchBusNew from '../../form/SearchBusNew';
const HomePage2 = () => {
	const dispatch = useDispatch();
	const [toggleFlight, setToggleFlight] = useState(true);
	const [toggleBus, setToggleBus] = useState(false);
	// const el = React.useRef(null);
	// const typed = React.useRef(null);
	// React.useEffect(() => {
	// 	const options = {
	// 		strings: [
	// 			'Welcome to <strong>Musafirbazar</strong>',
	// 			'Leave Your Footprints',
	// 		],
	// 		typeSpeed: 100,
	// 		backSpeed: 100,
	// 		// loop: true,
	// 	};

	// 	typed.current = new Typed(el.current, options);
	// }, []);
	useEffect(() => {
		dispatch(fetchBannerDispatch());
		dispatch(fetchCityDispatch());
	}, []);
	console.log(toggleFlight);
	console.log(toggleBus);
	const history = useHistory();
	return (
		<>
			<nav className='navbar' style={{ background: 'white' }}>
				<div className='container flex'>
					<a href='index.html' className='site-brand'>
						<img
							src={musafirbazarlogo}
							style={{ width: 280, display: 'block' }}></img>
					</a>

					<Hidden only={['xs', 'sm']}>
						<Box display='flex' alignItems='center'>
							<TitleText textStyle={{ fontSize: 24 }}>
								24x7 Customer Helpline
							</TitleText>
							<i
								class='fas fa-phone'
								style={{
									transform: 'rotate(90deg)',
									color: '#ef3339',
									fontSize: '28px',
									marginLeft: 20,
								}}></i>
							<Box onClick={() => (window.location = 'tel:887-777-3388')}>
								<TitleText textStyle={{ marginLeft: 10, fontSize: 20 }}>
									+91 887-777-3388
								</TitleText>
							</Box>

							<Box
								ml={'20px'}
								display='flex'
								alignItems='center'
								style={{
									background: '#ef3339',
									padding: '5px 14px',
									color: 'white',
									borderRadius: 5,
								}}>
								<i className='fas fa-user'></i>
								<TitleText textStyle={{ marginLeft: 10 }}>LOGIN</TitleText>
							</Box>
						</Box>
					</Hidden>
				</div>
			</nav>
			<header
				className='flex'
				style={{
					backgroundImage: `url(${header})`,
					minHeight: '100vh',
					paddingTop: '7rem',
				}}>
				<div className='container'>
					<Grid container>
						<Grid item xs={12} md={6}>
							<Box display='flex'>
								<Box
									onClick={() =>
										toggleFlight
											? setToggleFlight(false) || setToggleBus(true)
											: setToggleFlight(true) || setToggleBus(false)
									}
									alignItems='center'
									display='flex'
									style={{
										padding: 15,
										cursor: 'pointer',
										color: 'white',
										background: toggleFlight ? 'black' : 'rgba(0, 0, 0, 0.5)',
										fontWeight: toggleFlight ? '500' : '',
										borderTopLeftRadius: 23,
									}}>
									<i class='fa fa-plane' aria-hidden='true'></i>
									<TitleText textStyle={{ fontSize: 20, marginLeft: 10 }}>
										Flight
									</TitleText>
								</Box>
								<Box
									onClick={() =>
										toggleFlight
											? setToggleFlight(false) || setToggleBus(true)
											: setToggleFlight(true) || setToggleBus(false)
									}
									alignItems='center'
									display='flex'
									style={{
										padding: 15,
										cursor: 'pointer',
										color: 'white',
										background: toggleBus ? 'black' : 'rgba(0, 0, 0, 0.5)',
										fontWeight: toggleBus ? '500' : '',
									}}>
									<i class='fa fa-bus' aria-hidden='true'></i>
									<TitleText textStyle={{ fontSize: 20, marginLeft: 10 }}>
										Buses
									</TitleText>
								</Box>
							</Box>
							<div className='header-form'>
								{toggleFlight ? <SearchFlightNew /> : <SearchBusNew />}
								{/* {toggleFlight && } */}
								{/* <form className='flex'>
							<input
								type='text'
								className='form-control'
								placeholder='Destination name'
							/>
							<input type='date' className='form-control' placeholder='Date' />

							<input type='submit' className='btn' value='Search' />
						</form> */}
							</div>
						</Grid>
						<Grid item xs={12} md={6}>
							<img src={pngwin} style={{ width: 284 }}></img>
							{/* <marquee direction='right' width='855px'>
								<img src={pngwin} style={{ width: 513 }}></img>
							</marquee> */}
						</Grid>
					</Grid>

					{/* <div className='header-title'>
						<h1
							ref={el}
							style={{
								fontSize: '3em',
								margin: '0.67em 0',
								textAlign: 'center',
								color: 'white',
							}}></h1>
						<p style={{ fontSize: '14px', color: 'white' }}>
							Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus
							rerum maxime enim odit illum in molestias beatae doloremque,
							ratione optio.
						</p>
					</div> */}
				</div>
			</header>
			{toggleFlight ? (
				''
			) : (
				<section className='home' id='home'>
					<div className='image'>
						<img src={bushome} alt='q' />
					</div>

					<div className='content'>
						<h3>adventure is worthwhile</h3>
						<p>
							Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis
							explicabo eius inventore reprehenderit alias eos facilis, ipsa est
							asperiores repellendus!
						</p>
						<a href='#' className='btn'>
							explore now
						</a>
					</div>
				</section>
			)}

			<section id='featured' className='py-4'>
				<div className='container'>
					<div className='title-wrap'>
						<span className='sm-title' style={{ fontSize: '2rem' }}>
							know about some places before your travel
						</span>
						<h2 className='lg-title' style={{ fontSize: '2rem' }}>
							featured places
						</h2>
					</div>

					<div className='featured-row'>
						<div className='featured-item my-2 shadow'>
							<img
								src={featured}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span
									style={{
										fontSize: 14,
										display: 'flex',
										alignItems: 'center',
									}}>
									<i className='fas fa-map-marker-alt'></i>
									<p style={{ marginLeft: 5 }}> Reo De Janeiro, Brazil</p>
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>

						<div className='featured-item my-2 shadow'>
							<img
								src={featuredaustralia}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span
									style={{
										display: 'flex',
										fontSize: 14,
										alignItems: 'center',
									}}>
									<i className='fas fa-map-marker-alt'></i>
									<p style={{ marginLeft: 5 }}>North Bondi, Australia</p>
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>

						<div className='featured-item my-2 shadow'>
							<img
								src={featuredgermany}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span
									style={{
										fontSize: 14,
										display: 'flex',
										alignItems: 'center',
									}}>
									<i className='fas fa-map-marker-alt'></i>
									<p style={{ marginLeft: 5 }}>Berlin, Germany</p>
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>

						<div className='featured-item my-2 shadow'>
							<img
								src={featuredthailand}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span
									style={{
										fontSize: 14,
										display: 'flex',
										alignItems: 'center',
									}}>
									<i className='fas fa-map-marker-alt'></i>
									<p style={{ marginLeft: 5 }}>Khwaeng wat arun, thailand</p>
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>

						<div className='featured-item my-2 shadow'>
							<img
								src={featureditaly}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span
									style={{
										fontSize: 14,
										display: 'flex',
										alignItems: 'center',
									}}>
									<i className='fas fa-map-marker-alt'></i>
									<p style={{ marginLeft: 5 }}>Rome, Italy</p>
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>

						<div className='featured-item my-2 shadow'>
							<img
								src={featuredmaldives}
								alt='featured place'
								style={{ width: '100%', display: 'block' }}
							/>
							<div className='featured-item-content'>
								<span
									style={{
										fontSize: 14,
										display: 'flex',
										alignItems: 'center',
									}}>
									<i className='fas fa-map-marker-alt'></i>
									<p style={{ marginLeft: 5 }}>fuvahmulah, maldives</p>
								</span>
								<div>
									<p className='text'>
										Lorem ipsum, dolor sit amet consectetur adipisicing elit.
										Dicta sed dignissimos libero soluta illum, harum amet
										excepturi sit?
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section
				id='servicess'
				className='py-4'
				style={{ backgroundImage: `url(${service})` }}>
				<div className='container'>
					<div className='title-wrap'>
						<span className='sm-title' style={{ fontSize: '2rem' }}>
							know about services that we offer
						</span>
						<h2 className='lg-title' style={{ fontSize: '2rem' }}>
							Our services
						</h2>
					</div>

					<div className='services-row'>
						<div className='services-item'>
							<span className='services-icon'>
								<i className='fas fa-hotel'></i>
							</span>
							<h3>Luxurious Hotel</h3>
							<p className='text'>
								Tour Packages are one of the best ways to travel hassle-free.
								With seamless planning, arrangements, and transfers being taken
								care of, booking tour packages from india is the best way to
								explore the world’s varied landscapes.
							</p>
							<a href='#' className='btn'>
								Read more
							</a>
						</div>

						<div className='services-item'>
							<span className='services-icon'>
								<i className='fas fa-plane'></i>
							</span>
							<h3>Fastest Travel Booking</h3>
							<p className='text'>
								Book Your Flight And Train Tickets Online Without Going Through
								Any Hassle. Check Availability Of Seats, Schedule And Compare
								Fares For Both Domestic As Well As Foreign Travel.
							</p>
							<a href='#' className='btn'>
								Read more
							</a>
						</div>

						<div className='services-item'>
							<span className='services-icon'>
								<i className='fas fa-bus'></i>
							</span>
							<h3>Bus Booking</h3>
							<p className='text'>
								A bus reservation system is a mobile or web software solution
								designed to provide customers with a personalized
								easy-to-utilize user experience for booking and purchasing
								tickets online.
							</p>
							<a href='#' className='btn'>
								Read more
							</a>
						</div>
					</div>
				</div>
			</section>
			<section id='testimonials' className='py-4'>
				<div className='container'>
					<div className='title-wrap'>
						<span className='sm-title' style={{ fontSize: 22 }}>
							what our clients say about us
						</span>
						<h2 className='lg-title' style={{ fontSize: 20 }}>
							testimonials
						</h2>
					</div>

					<div className='test-row'>
						<div className='test-item'>
							<p className='text'>
								Lorem ipsum dolor sit amet consectetur adipisicing elit.
								Assumenda blanditiis, asperiores, velit iste eos officiis
								tempora magni quaerat quo consectetur expedita cum recusandae
								facere nam voluptate minus iusto eum. Delectus!
							</p>
							<div className='test-item-info'>
								<img src={test1} alt='testimonial' />
								<div>
									<h3>Kevin Wilson</h3>
									<p className='text'>Trip to Brazil</p>
								</div>
							</div>
						</div>

						<div className='test-item'>
							<p className='text'>
								Lorem ipsum, dolor sit amet consectetur adipisicing elit. Sed ut
								dolores tenetur harum deserunt. Maxime tenetur consectetur
								recusandae nobis fugit iusto natus quibusdam nulla!
							</p>
							<div className='test-item-info'>
								<img src={test2} alt='testimonial' />
								<div>
									<h3>Ben Davis</h3>
									<p className='text'>Trip to Maldives</p>
								</div>
							</div>
						</div>

						<div className='test-item'>
							<p className='text'>
								Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quidem
								sapiente amet expedita quae autem deleniti quo magni numquam
								facilis soluta dicta, praesentium ipsum, quos optio sed
								quibusdam! Reprehenderit recusandae provident id nemo!
							</p>
							<div className='test-item-info'>
								<img src={test3} alt='testimonial' />
								<div>
									<h3>Jaura Jones</h3>
									<p className='text'>Trip to Thailand</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <section id='video' style={{ padding: 0 }}>
				<div className='video-wrapper flex'>
					<video loop>
						<source src={videos} type='video/mp4' />
					</video>
					<button
						type='button'
						id='play-btn'
						onClick={() => {
							let video = document.querySelector('.video-wrapper video');
							if (video.paused) {
								video.play();
							} else {
								video.pause();
							}
						}}>
						<i className='fas fa-play'></i>
					</button>
				</div>
			</section> */}
			<footer className='py-4'>
				<div className='container footer-row'>
					<div className='footer-item'>
						<h2>Musafir Bazar</h2>
						<ul>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Company Info
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Company Policy
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Privacy Policy
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Terms & Conditions
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									About Us
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Cancellation/ Refund Policy
								</a>
							</li>
						</ul>
					</div>

					<div className='footer-item'>
						<h2>Follow us on: </h2>
						<ul className='social-links'>
							<li>
								<a
									style={{ fontSize: 22 }}
									href='https://www.facebook.com/musafirbazaar'
									target='_blank'>
									<i className='fab fa-facebook-f'></i>
								</a>
							</li>
							<li>
								<a
									style={{ fontSize: 22 }}
									href='https://www.instagram.com/musafirbazar/'
									target='_blank'>
									<i className='fab fa-instagram'></i>
								</a>
							</li>
							<li>
								<a
									style={{ fontSize: 22 }}
									href='https://twitter.com/musafirbazar'
									target='_blank'>
									<i className='fab fa-twitter'></i>
								</a>
							</li>
							<li>
								<a style={{ fontSize: 22 }} href='#'>
									<i className='fab fa-pinterest'></i>
								</a>
							</li>
							<li>
								<a style={{ fontSize: 22 }} href='#'>
									<i className='fab fa-google-plus'></i>
								</a>
							</li>
						</ul>
					</div>

					<div className='footer-item'>
						<h2>Products</h2>
						<ul>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Flight Booking
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Bus Booking
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Car Booking
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Holiday Package
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Hotel Booking
								</a>
							</li>
						</ul>
					</div>
					<div className='footer-item'>
						<h2>Contact Info</h2>
						<ul>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									+91 8877773388
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									sales@musafirbazaar.com
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									1st Floor,New Tech Grand, Bank More, Dhanbad-826001
								</a>
							</li>
						</ul>
					</div>
					{/* <div className='subscribe-form footer-item'>
						<h2>Subscribe for Newsletter!</h2>
						<form className='flex'>
							<input
								type='email'
								placeholder='Enter Email'
								className='form-control'
							/>
							<input type='submit' className='btn' value='Subscribe' />
						</form>
					</div> */}
				</div>
			</footer>
		</>
	);
};

export default HomePage2;
